// ============================================
// VENUE MODELS
// Based on iOS CreateVenueView.swift
// ============================================

export enum ShopType {
  woocommerce = 2,
  hype = 3
}

export interface Country {
  id: number;
  name: string;
  code: string;
  countryFlag?: string;
  phonePrefix?: string;
  supportedShopTypes?: number[];
}

export interface Currency {
  id: number;
  name: string;
  code: string;
  symbol?: string;
}

export interface ClientLocation {
  id?: number;
  name?: string;
  locationAddressName?: string;
  lat?: number;
  lng?: number;
  isPickupLocation?: boolean;
}

export interface CreateVenueRequest {
  name: string;
  city: string;
  countryId: number;
  currencyId: number;
  secondCurrencyId?: number;
  shop_status_id: number;
  shop_onboarding_status_id: number;
  creator_device_id: string;
  catalogue_icon?: string; // base64 encoded image
  location?: {
    name: string;
    location_address_name: string;
    lat: number;
    lng: number;
    is_pickup_location: boolean;
  };
  sales_representative_id?: number;
  shop_type?: number;
  auth_key?: string;
}

export interface CreateVenueResponse {
  id: number;
  name: string;
  city: string;
  countryId: number;
  currencyId: number;
  [key: string]: any;
}
